export const SECOND = 1000;
export const MINUTE = SECOND * 60;
export const HOUR = MINUTE * 60;

export const timeout = (ms = 0): Promise<void> => new Promise((resolve) => setTimeout(resolve, ms));
